import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Grid } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import get from 'lodash/get';

import Card from '../components/Card';
import ThreatIndexBar from '../components/ThreatIndexBar';

const ThreatIndex = () => {
  const { threatIndex: data } = useSelector((state) => state.ecosystems.ecosystem);
  const isLoading = useSelector((state) => get(state.ecosystems.ecosystem.loading, 'index', false));

  const external = Number((data?.External || 0).toFixed(1));
  const internal = Number((data?.Internal || 0).toFixed(1));

  return (
    <Card icon={TrendingUpIcon} isLoading={isLoading} title="Threat Index">
      <Grid container>
        <Grid item xs={6} sx={{ px: 4.5, py: 3.5 }}>
          <Typography sx={{ mb: 2, lineHeight: '28px' }}>External</Typography>
          <ThreatIndexBar low={4} medium={6} high={8} markerValue={external} index="external" />
        </Grid>
        <Grid item xs={6} sx={{ px: 4.5, py: 3.5, borderLeft: '1px solid #EFF2F7' }}>
          <Typography sx={{ mb: 2, lineHeight: '28px' }}>Internal</Typography>
          <ThreatIndexBar low={1} medium={4} high={7} markerValue={internal} index="internal" />
        </Grid>
      </Grid>
    </Card>
  );
};

export default ThreatIndex;
